import type { MouseEvent } from 'react';

/** True when the user selected text (e.g. to copy) — navigation should not run. */
export function shouldSuppressNavigationClick(
  event: MouseEvent,
  pointerDown: { x: number; y: number } | null,
  dragThresholdPx = 4,
): boolean {
  if (pointerDown) {
    const moved = Math.hypot(
      event.clientX - pointerDown.x,
      event.clientY - pointerDown.y,
    );
    if (moved > dragThresholdPx) {
      return true;
    }
  }

  const selection = window.getSelection();
  return Boolean(selection && selection.toString().length > 0);
}
